export default "__VITE_ASSET__CL7$Se3O__"